import { createContext } from "react";

export const TMDataContext = createContext(null);
